export const ENDPOINTS = {
  DEAERATORS: "deaerators",
  DEAERATORS_PHC: "deaerators-phc",
  DEAERATOR_PHC_MATERIAL: "deaerators-phc-material",
  BUDGET: "budget",
  BUDGET_EXCEL: "deaerator-budget",
  USERS: "users",
  MPMETAL_SHEET: "mp-metal-sheet-table",
  MP_STAIN_STEEL_TEMP_TABLE: "mp-stain-steel-temp-table",
  MP_STAIN_STEEL_TABLE: "mp-stain-steel-table",
  MP_STEEL_ELEVATED_TEMP_TABLE: "mp-steel-elevated-temp-table",
  MP_TUBE_ELEVATED_TEMP_TABLE: "mp-tube-elevated-temp-table",
  MP_TUBE_ROOM_TEMP: "mp-tube-room-temp-table",
  MP_TENSILE_STRENGTH_TEMP_TABLE: "mp-tensile-strength-temp-table",
  VACUUM_BREAKER: "vacuum-breaker/select",
  WELD_HOURS_TABLE: "weld-hours-table",
  PRICE_PER_HOUR: "price-per-hour",
  GESTRA_PRICE_TABLE: "gestra-price-table",
  PAINT_SCHEME_TABLE: "paint-scheme-table",
  SPIRAX_SARCO_PRICE_TABLE: "spirax-sarco-price-table",
};


